module.exports = __webpack_public_path__ + "img/6-min.76e1a7c.png";